import { AppDispatch } from '@app/model/store/client'
import type { TypeMappingPaginationOutput as MappedPagination } from '@shared/api/middleware/mappingAPI/pagination/type'
import type { TypeMappingSelectionOutput as MappedSelection } from '@shared/api/middleware/mappingAPI/selection/type'
import type { PropsRestaurantListParams } from '@shared/api/types/apiPublicParameters'
import type { ListingRestaurant } from '@pages/Listing/model/types'
import {
  setList,
  setLoadingPage,
  setPagination,
  setSelectionsSection,
  setParamsRequest,
  setTitle,
  setDescription,
  setReady,
} from '@pages/Listing/model/slice'

export const initListingItem =
  (data: { paramsRequest: PropsRestaurantListParams; selections: MappedSelection[] }) => (dispatch: AppDispatch) => {
    dispatch(setSelectionsSection(data.selections))
    dispatch(setParamsRequest(data.paramsRequest))
    dispatch(setReady(true))
  }

export const initRestaurantList =
  (data: { list: ListingRestaurant[]; pagination: MappedPagination | null }) => (dispatch: AppDispatch) => {
    dispatch(setList(data.list))
    dispatch(setPagination(data.pagination))
    dispatch(setLoadingPage(false))
  }

export const setTitleAndDescriptionListingAC =
  (seoTitle: string, seoDescription: string) => (dispatch: AppDispatch) => {
    dispatch(setDescription(seoDescription || ''))
    dispatch(setTitle(seoTitle || ''))
  }
